import { CustomBlock, BlockMutator } from '@ng-blockly/blockly';
declare var Blockly: any;

/**
 * 自定义逻辑判断，使用mutator来动态调整输入条件的个数，顺序等等
 */
export class AndOrBlock extends CustomBlock {
  jsonBlock = {
    type: 'logic_block_self_add',
    message0: '%1 %2 %3',
    args0: [
      {
        type: 'field_dropdown',
        name: 'NAME',
        options: [
          ['且', 'AND'],
          ['或', 'OR']
        ]
      },
      {
        type: 'input_value',
        name: 'NAME1',
        check: 'Boolean'
      },
      {
        type: 'input_value',
        name: 'NAME2',
        check: 'Boolean'
      }
    ],
    mutator: 'blockly_self_add_mutator',
    inputsInline: false,
    output: 'Boolean',
    style: 'logic_blocks',
    tooltip: '',
    helpUrl: ''
  };

  constructor(
    type: string,
    block: any,
    blockMutator: BlockMutator,
    ...args: any[]
  ) {
    super(type, block, blockMutator, ...args);
    this.class = AndOrBlock;
    this.loadBlockInMutator();
  }

  defineBlock() {
    this.block.jsonInit(this.jsonBlock);
  }

  /**
   * 默认有两个输入条件：items="2"
   *
   * @returns
   * @memberof AndOrBlock
   */
  toXML() {
    return `<block type='${this.type}'>
      <mutation items="2"></mutation>
      <field name="NAME">AND</field>
    </block>`;
  }

  toJavaScriptCode(e: any) {
    const inputList = this.block.inputList;
    const dropdownName = e.getFieldValue('NAME') === 'AND' ? '&&' : '||';
    let code = '';
    for (let i = 1; i <= inputList.length; i++) {
      const temp = Blockly.JavaScript.valueToCode(
        e,
        `NAME${i}`,
        Blockly.JavaScript.ORDER_ATOMIC
      );
      if (i < inputList.length) {
        code += temp + dropdownName;
      } else {
        code += temp;
      }
    }
    // TODO: Change ORDER_NONE to the correct strength.
    return [code, Blockly.JavaScript.ORDER_NONE];
  }

  onChange(changeEvent: any) {
    // console.log(changeEvent);
  }

  /**
   * 加载mutator中使用到的block,这些block不需要转化为代码，只是用来构造source block的结构（例如增删inputs数量）
   */
  loadBlockInMutator() {
    // tslint:disable-next-line: no-string-literal
    if (
      !Blockly.Blocks['block_self_boolean'] ||
      !Blockly.Blocks['block_self_mutator']
    ) {
      Blockly.defineBlocksWithJsonArray([
        {
          type: 'block_self_boolean',
          message0: '布尔值',
          inputsInline: false,
          previousStatement: null,
          nextStatement: null,
          colour: '%{BKY_LOGIC_HUE}'
        },
        {
          type: 'block_self_mutator',
          message0: '%1',
          args0: [
            {
              type: 'input_statement',
              name: 'NAME',
              check: 'Boolean'
            }
          ],
          colour: '%{BKY_LOGIC_HUE}',
          tooltip: ''
        }
      ]);
    }
  }
}
